import { createContext, use } from 'react'

export const EmblaCarouselContext = createContext<HTMLElement[]>([])

export function useCarouselItemsInView(ref: React.RefObject<HTMLElement | null>) {
  const context = use(EmblaCarouselContext)

  return {
    isVisibleItem: Boolean(context.find(item => item === ref.current)),
  }
}
